var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Laptop_orange"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laptop_orange",
    "data-name": "Laptop orange",
    clipPath: "url(#clip-Laptop_orange)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(20434 13920)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-laptop",
    "data-name": "Icon awesome-laptop",
    d: "M25.388,16.334H15.523a1.263,1.263,0,0,1-1.332,1.256H11.718a1.358,1.358,0,0,1-1.333-1.256H.651A.642.642,0,0,0,0,16.962v.628A2.567,2.567,0,0,0,2.6,20.1H23.435a2.567,2.567,0,0,0,2.6-2.513v-.628A.642.642,0,0,0,25.388,16.334ZM23.435,1.885A1.925,1.925,0,0,0,21.482,0H4.557A1.925,1.925,0,0,0,2.6,1.885V15.078H23.435Zm-2.6,10.68H5.208V2.513H20.831Z",
    transform: "translate(-20432 -13915)",
    fill: "#fd9d1e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_3890",
    "data-name": "Path 3890",
    transform: "translate(-20421.541 -13898.188)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.15-.464H5.4l.107,2.356H-.043Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -0.1503944396972656 -0.4638688564300537 L 5.404605388641357 -0.4638688564300537 L 5.512025356292725 1.89211106300354 L -0.04297447204589844 1.89211106300354 L -0.1503944396972656 -0.4638688564300537 Z",
    stroke: "none",
    fill: "#fd9d1e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopOrange);
export default __webpack_public_path__ + "static/media/laptop_orange.dbd22ca20d74c4ebff014882e9aa8294.svg";
export { ForwardRef as ReactComponent };